module.exports = __webpack_public_path__ + "media/images/how_first-8ae357c3358e4fcedb33a866fabac537.svg";